/*
 * @Desc:
 * @Version: v1.00
 * @Author: went
 * @Date: 2021-08-26 10:20:47
 * @LastEditors: your name
 * @LastEditTime: 2025-02-19 15:26:33
 */
// import registerAntd from "./register-antdv";
import registerComponents from "./register-components";
export function registerApp(vue) {
  // registerAntd(vue);
  registerComponents(vue);
}
